import { executionDecision, selectedCommandStatus } from "./consolidationExecution.js";
import { flaggedTimes } from "./consolidationSheetChecks.js";

// Écarts au Dispatch qu'un relevé enregistré et non validé soumet à la personne qui valide.
export function sheetAttention(sheet) {
  const items = [];
  const visits = sheet.visits.filter(visit => visit.status !== "inherited");
  const orders = new Map(visits.flatMap(visit => visit.orders.map(order => [order.id, order])));
  for (const order of orders.values()) {
    const decision = executionDecision(sheet, order);
    if (selectedCommandStatus(order, decision) === "excluded") {
      items.push({ kind: "not_delivered", text: `${order.label} non livrée${decision?.reason ? ` : ${decision.reason}` : ""}` });
      continue;
    }
    if ([order.hourly_rate_override, order.loading_tonne_rate_override, order.fixed_rate_override].some(value => value != null && String(value).trim() !== "")) {
      items.push({ kind: "rate", text: `${order.label} : tarif exceptionnel` });
    }
  }
  const sequence = key => [...sheet.visits].sort((a, b) => a[key] - b[key]).map(visit => visit.id).join();
  if (sequence("actual_sequence") !== sequence("planned_sequence")) {
    items.push({ kind: "order", text: "Ordre des arrêts modifié : la répartition des heures entre clients change" });
  }
  const times = flaggedTimes(sheet);
  if (times) items.push({ kind: "times", count: times, text: `${times} horaire${times > 1 ? "s" : ""} à vérifier` });
  if (sheet.notes || visits.some(visit => visit.notes)) items.push({ kind: "notes", text: "Note saisie dans le relevé" });
  return items;
}
